const mapFrameContentStyles = {
  "& .MuiCardContent-root": {
    p: "unset !important",
  },
  m: "unset",
  p: "unset !important",
};

export const headerButtonMobile = {
  padding: "0px !important",
  width: "100% !important",
  marginTop: "12px",
};

const mapFrameCardSXStyles = {
  m: "unset",
  p: "24px 16px",
  borderColor: "#EEEEEE",
};

const orderDetailsHeading = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: "6px 20px",
  borderRadius: "12px",
  height: "fit-content",
  mt: { xs: "24px", lg: "2px" },
  ml: "8px",
};

const currencyStyles = {
  fontStyle: "normal",
  fontSize: "10px",
  color: "#757575",
  pb: "1.85px !important",
};

export const tableCurrencyStyles = {
  fontStyle: "normal",
  fontSize: "11px",
  color: "#757575",
  lineHeight: "9px",
};

const searchNoDataStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #EEEEEE",
  p: "18px",
  mb: "24px",
};

const bulkOrderConversionStyle = {
  "& .MuiSvgIcon-root": {
    color: "#212121",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiOutlinedInput-root input::placeholder": {
    color: "#212121",
    opacity: 1,
    fontSize: 13,
    fontWeight: "500",
  },

  "& .MuiOutlinedInput-root": {
    height: "41px",
    borderRadius: "58px",
    background: "#F5F5F5",

    "& fieldset": {
      borderColor: "#bababa",
      borderWidth: 0.8,
    },
    "&:hover fieldset": {
      borderColor: "#e51451",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 0.8,
      borderColor: "#e51451",
    },
    "&.MuiOutlinedInput-root input": {
      color: "#212121",
      fontSize: 13,
      fontWeight: "500",
    },

    "&.MuiOutlinedInput-root .MuiTypography-root": {
      color: "#545454",
      fontSize: 13,
      fontWeight: "200",
    },
    "& .MuiOutlinedInput-input": {
      padding: "2px !important",
      background: "#F5F5F5",
    },
  },
};

const gridIconsCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  color: "#212121",
};

const filtersStyles = {
  width: { xs: "100%", md: "160px" },
  height: "40px",
  ml: { md: "10px" },
  mb: { xs: "10px", md: "0" },
};

const mainCardSX = {
  m: "unset",
  borderRadius: "unset",
  border: "none",
  p: {
    xs: "22px 15px",
    md: "35px 40px",
    lg: "48px 55px",
  },
};

const productItemsTableStyle = {
  width: "100%",

  "& .MuiDataGrid-root": {
    border: "none",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    color: "#212121",
  },
  "& .MuiDataGrid-columnHeader": {
    pr: "unset",
    pl: "15px",
  },
  "& .MuiDataGrid-columnHeaders": {
    borderBottom: "1px solid #EEEEEE",
  },
  "& .MuiIconButton-root": {
    p: "unset",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    {
      outline: "none",
    },
  "& .MuiDataGrid-row": {
    maxHeight: "fit-content !important",
    borderBottom: "1px solid #EEEEEE",
    ":last-child": { borderBottom: "none" },
  },
  "& .MuiDataGrid-cell": {
    maxHeight: "fit-content !important",
    overflow: "auto",
    whiteSpace: "initial !important",
    lineHeight: "16px !important",
    display: "flex !important",
    alignItems: "start",
    p: "25px 0px 25px 15px",
    borderBottom: "unset",
  },
  "& .MuiDataGrid-virtualScrollerContent": {
    height: "100% !important",
    width: "100% !important",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    position: "unset",
  },
};

const responsiveAlignmentStart = {
  mt: "14px",
  justifyContent: {
    xs: "flex-start",
    md: "end",
  },
  textAlign: {
    xs: "flex-start",
    md: "end",
  },
};

const responsiveAlignmentEnd = {
  mt: "14px",
  justifyContent: {
    xs: "flex-end",
    md: "end",
  },
  textAlign: {
    xs: "flex-end",
    md: "end",
  },
  alignItems: "flex-end",
};

const actionModalSX = {
  position: "absolute",
  m: "unset",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", md: "40vw" },
  p: { xs: "18px", md: "30px", lg: "40px" },
  border: "none",
};

const imagePreviewStyles = {
  height: { xs: "30vh", md: "50vh" },
  width: { xs: "80vw", md: "25vw" },
  borderRadius: "8px",
  m: "10px",
};

const modalPaperStyles = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", md: "65vw" },
  position: "absolute",
};

const optionItemBoxStyles = {
  marginTop: "16px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  color: "#000000",
  borderRadius: "8px",
  marginBottom: "8px",
  p: { xs: "8px", md: "16px" },
};

const switchMarginUnset = {
  "& .MuiFormControlLabel-root": {
    m: "unset",
  },
};

const textAreaStyles = {
  "& .MuiOutlinedInput-root": {
    height: "unset !important",
  },

  mb: "24px",
};

export const iconStyles = { pl: "4px", color: "#979797" };

export const tooltipBoxStyles = { display: "flex", alignItems: "center" };

export const subscriptionTypeStyles = {
  ...orderDetailsHeading,
  backgroundColor: "#F5F5F5",
  color: "#000",
};

export const ordersHeadingBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: { xs: "100%", md: "unset" },
};

export const shortPillStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "55px",
  height: "34px",
  background: "#E1E3E8",
  borderRadius: "100px",
};

export const orderIdGridStyles = {
  display: "flex",
  alignItems: "center",
  pr: { xs: "0px !important", md: "0" },
  mb: { xs: "14px", md: "0" },
  width: "100%",
};

export const orderIdStackStyles = {
  width: { xs: "100%", lg: "unset" },
  display: { xs: "grid", lg: "flex" },
};

export const headerOrderInfoStack = {
  overflowX: "auto",
  width: { xs: "100%", lg: "unset" },
  pb: { xs: "10px", md: "0" },
  "& h6": { whiteSpace: "nowrap" },
  "& h6:first-child": {
    ml: { xs: "0", lg: "8px" },
  },
};

export const orderDetailHeaderParent = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: { xs: "unset", md: "start" },
  position: { xs: "relative", md: "unset" },
};

export const headerButtonSection = {
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "space-around", md: "flex-end" },
  flexDirection: { xs: "column", md: "row" },
};

export const filtersParentGrid = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  mb: "16px",
};

export const headerSectionGrid = {
  display: "flex",
  alignItems: { xs: "start", sm: "center" },
  flexDirection: { xs: "column", md: "row" },
};

export const modalButtonStyles = {
  p: "13px 44px",
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
};

export const orderPrintStack = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const orderPrinterButton = {
  fontSize: "12px",
  background: "#F5F5F5 ",
  color: "#212121",
  p: "0",
  "&:hover": {
    backgroundColor: "#F5F5F5",
  },
  ml: "4px",
};

export {
  textAreaStyles,
  switchMarginUnset,
  mapFrameContentStyles,
  mapFrameCardSXStyles,
  orderDetailsHeading,
  currencyStyles,
  searchNoDataStyles,
  bulkOrderConversionStyle,
  gridIconsCss,
  filtersStyles,
  mainCardSX,
  productItemsTableStyle,
  actionModalSX,
  imagePreviewStyles,
  modalPaperStyles,
  optionItemBoxStyles,
  responsiveAlignmentStart,
  responsiveAlignmentEnd,
};
